import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 */
// eslint-disable-next-line import/prefer-default-export
export function selectHeader (state) {
  return state.header || Map()
}
